import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';
import { normalizeRoutePath } from '@/lib/utils';

const routePath = '/settings/preboarding-forms' as const;
export const Route = createFileRoute(routePath)({
  // The forms list is a tab of the Settings page, mounted from `?tab=`; a direct hit on
  // the bare path bounces there before this route loads, so the header matches the
  // section on screen. The route stays as the layout parent for the wizard ($id).
  beforeLoad: ({ location }) => {
    if (normalizeRoutePath(location.pathname) === normalizeRoutePath(routePath)) {
      throw redirect({ to: '/settings', search: { tab: 'preboarding-forms' } });
    }
  },
  component: PreboardingFormsRoute,
});

function PreboardingFormsRoute() {
  return <Outlet />;
}
